import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'dropdown' })
export class FilterPipe implements PipeTransform {

  transform(list: any[], data: any) {
    data.text = data.text && data.text.normalize('NFD').trim().toLowerCase();
    if (data.text) {
      return this.listReturned(list, data);
    } else {
      return list;
    }
  }

  private listReturned(list: any[], data): any[] {
    return list.filter(x => data.type ?
      this.prepare(x[data.type]).includes(this.prepare(data.text))
      :
      this.prepare(x).includes(this.prepare(data.text)));
  }

  private prepare(value: string): string {
    if (value) {
      return this.removeAccents(value.normalize().toLowerCase());
    }
    return null;
  }

  private removeAccents(value: string) {
    return value
      .replace(/[áàãâä]/gi, 'a')
      .replace(/[éè¨ê]/gi, 'e')
      .replace(/[íìïî]/gi, 'i')
      .replace(/[óòöôõ]/gi, 'o')
      .replace(/[úùüû]/gi, 'u')
      .replace(/[ç]/gi, 'c')
      .replace(/[ñ]/gi, 'n')
      .replace(/[^a-zA-Z0-9]/g, ' ');
  }
}
